import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-select {
    width: 100%;
  }
  margin: auto;
`;
